import React, {Component} from 'react';
import logo from '../images/genesys-logo.png';
import logo_2x from '../images/genesys-logo@2x.png';
import desktopImg from '../images/desktop-only.png';
import Script from 'react-load-script'

import {Translate, withLocalize} from 'react-localize-redux';

class DesktopOnly extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sendEmail: null,
      formShow: true,
      gated: window.gated == "true" || window.gated == "%REACT_APP_GATED%",
    };

    let ctaString = window.location.search.substring(1, window.location.search.length);
    if (ctaString.includes("site=zinfi")) {
      this.state.formShow = false;
    }

    this.updateEmail = this.updateEmail.bind(this);
    this.redirect = this.redirect.bind(this);
  }

  redirect(){
    window.location.href = "https://www.genesys.com"
  }

  updateEmail(e) {
    this.setState({sendEmail: e.target.value});
  }

  handleScriptLoad(){

    setTimeout(()=>{
      // Vanilla
      let mkt_obj={
        form_type:"",
        lang: document.documentElement.lang,
        form_id:"8701", // NOTICE: if modified, must change in markup
        landing_id:"8701",
        cid_id:"7010d000000mWn2",
        cms_hold:"default",
        action:"inline",
        url:"#",
        target:"",
        button: this.props.translate("desktopOnlySendLink"),
        clean:"enable",
        post_id:"13697",
        trans:"",
        script_load:"",
        script_ready:"",
        script_submit: this.redirect,
        gdpr_add_msg:"",
        gdpr_attr:"",
        gdpr_val: ""
      };

      if(RequestForm) { // eslint-disable-line no-undef
        RequestForm(mkt_obj); // eslint-disable-line no-undef
      } else {
        alert('Marketo form not found.')
      }
    }, 200)


  }

  render() {

    let { formShow, gated } = this.state;

    return (
      <Translate>
        {({translate}) => {
          return (
            <div className="desktop-only_wrapper">

              <div className="desktop-only_content">

                <div className="content">
                  <a target="_blank" rel="noopener noreferrer" href="https://genesys.com"><img src={logo} srcSet={`${logo} 1x, ${logo_2x} 2x`} className="logo" alt="logo"/></a>

                  <img src={desktopImg} className="desktop" alt="desktop only"/>

                  <div className={ formShow ? "form-section" : "zinfi" }>
                    { !gated && formShow ? (<p>{translate("desktopOnlyEmailSentCopy")}</p>) : translate("desktopOnlyCopy")    }
                    { !gated && formShow ?  undefined : (

                      <div id="gmkto_form" className="gmkto_form gmkto_form_wp290 gmkto_format_vertical gmkto_brand_resource">

                        <Script
                          url="https://www.genesys.com/wp-content/plugins/genesys-hook-marketo/external/RequestFormExternal.js"
                          onLoad={this.handleScriptLoad.bind(this)}
                        />

                        <form id="mktoForm_8701" className="mktoForm form29">
                          <div id="known_person" style={{display: "none"}}><p className="welcome_user">
                            <span id="welcome_person"><Translate id="unlockModalWelcomeBack" /></span>
                            <span id="person_info"><span className="person_first"></span>&nbsp;
                              <span className="person_last"></span></span>
                          </p><p className="delete_button"><a className="deletemyrecord"><Translate id="unlockModalNotYou" /></a></p></div>
                        </form>

                      </div>
                    ) }
                  </div>
                </div>
              </div>

            </div>
          )
        }}
      </Translate>
    );
  }
}

export default withLocalize(DesktopOnly);



// WEBPACK FOOTER //
// ./src/components/DesktopOnly.jsx